import { debounce } from "lodash";
import getAnalyticsCustomConfigId from "./getAnalyticsCustomConfigId";

/**
 * Debounced version of the analytics tracking function for customization complete events
 */
const debouncedTrackCustomizationComplete = debounce(
  ({ userChoiceValues, customizationTime, stockStatus }) => {
    if (window[process.env.REACT_APP_ANALYTICS_FUNCTION]) {
      window[process.env.REACT_APP_ANALYTICS_FUNCTION].push({
        event: "customization_complete",
        custom_config_id: getAnalyticsCustomConfigId({ userChoiceValues }),
        customization_time: customizationTime,
        stock_status: stockStatus,
        timestamp: Date.now(),
      });
    } else {
      console.warn("Analytics function not defined");
    }
  },
  3000
); // Wait 3000ms before firing the event

/**
 * Tracks when a product customization is completed
 *
 * @param {Object} params - The parameters object
 * @param {Object} params.userChoiceValues - The user choice values for the customization
 * @param {number} params.customizationTime - The time taken to complete customization in milliseconds
 * @param {string} params.stockStatus - The stock status of the customized product
 */
const trackCustomizationComplete = ({
  userChoiceValues,
  customizationTime,
  stockStatus = "in_stock",
}) => {
  debouncedTrackCustomizationComplete({
    userChoiceValues,
    customizationTime,
    stockStatus,
  });
};

export default trackCustomizationComplete;
